import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import OnlinePaymentCheckoutPage from './OnlinePaymentCheckoutPage';
import { getOnlinePaymentInfoInitiate } from '../../../actions/payments';
import { refreshAuthInitiate } from '../../../actions/auth';
import { currentFlowTypeEnum } from '../../common/components/constants';
import { getInvoicesDetailsInitiate } from '../../../actions/company';

const mapStateToProps = state => {
  const paymentsInfo = _get(state, 'payments.paymentInfo', {});
  const invoiceDetails = _get(state, 'company.invoiceDetails', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const isOnlinePaymentsEnabled = _get(
    state,
    'user.supported_features.online_payments_enabled',
    false,
  );
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    isOnlinePaymentsEnabled,
    paymentsInfo,
    selectedWorkspace,
    fetchingOnlinePaymentInfo:
      _get(state, 'apiState.ONLINE_PAYMENT_INFO.isFetching', true) &&
      !_get(state, 'apiState.ONLINE_PAYMENT_INFO.isIdle', false),
    fetchedOnlinePaymentInfo: _get(
      state,
      'apiState.ONLINE_PAYMENT_INFO.success',
      true,
    ),
    refreshingAuth:
      _get(state, 'apiState.REFRESH_AUTH.isFetching', false) &&
      !_get(state, 'apiState.REFRESH_AUTH.isIdle', true),
    invoiceDetails,
    fetchingInvoiceDetails:
      _get(state, 'apiState.GET_INVOICE_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_INVOICE_DETAILS.isIdle', false),
    fetchedInvoiceDetails: _get(
      state,
      'apiState.GET_INVOICE_DETAILS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getInvoiceDetails: payload => dispatch(getInvoicesDetailsInitiate(payload)),
  getOnlinePaymentInfo: payload =>
    dispatch(getOnlinePaymentInfoInitiate(payload)),
  refreshAuth: () => dispatch(refreshAuthInitiate()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnlinePaymentCheckoutPage);
